/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
var _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { action } from "@ember/object";
import Component from "@glimmer/component";
import { DocumentStatus, DocumentVisibility } from "cnam/types/types";
import dmpDocumentTypeCodes from "cnam/utils/dmp-document-type-codes";
import formatToISO8601Date from "core/utils/format-to-iso8601-date";
let DocumentsRetrieveAccessFormSearchComponent = (_class = class DocumentsRetrieveAccessFormSearchComponent extends Component {
  constructor(owner, args) {
    super(owner, args);
  }
  get title() {
    return `Recherche de documents DMP${this.args.context.secretConnection ? " - Connexion secrète en cours" : ""}`;
  }
  setLastDmpDocumentsSearchDate(value) {
    this.args.context.medic.lastDmpDocumentsSearchDate = value;
    this.args.context.medic.save();
  }
  get dmpDocumentTypeCodes() {
    return dmpDocumentTypeCodes;
  }
  get lastSubmissionStartTimeFrom() {
    const lastSearchDateString = this.args.context.medic.lastDmpDocumentsSearchDate;
    return lastSearchDateString ? new Date(lastSearchDateString) : undefined;
  }
  get serviceStartTimeFromDate() {
    return this.args.context.searchParams.serviceStartTimeFrom ? new Date(this.args.context.searchParams.serviceStartTimeFrom) : undefined;
  }
  get serviceStopTimeToDate() {
    return this.args.context.searchParams.serviceStopTimeTo ? new Date(this.args.context.searchParams.serviceStopTimeTo) : undefined;
  }
  get submissionStartTimeFromDate() {
    return this.args.context.searchParams.submissionStartTimeFrom ? new Date(this.args.context.searchParams.submissionStartTimeFrom) : undefined;
  }
  getClassCodeDisplayName(classCode) {
    // Loop through DMP
    const dmpClass = dmpDocumentTypeCodes.find(dmpClass => dmpClass.classCode == classCode);
    return dmpClass ? dmpClass.displayName : classCode;
  }
  getStatusString(statuses) {
    const status = [];
    if (statuses.includes(DocumentStatus.DEPRECATED)) {
      status.push("ancienne version obsolète");
    }
    if (statuses.includes(DocumentStatus.ARCHIVED)) {
      status.push("archivé");
    }
    return status.join(", ");
  }
  getVisibilityString(confidentialities) {
    const visibility = [];
    if (confidentialities.includes(DocumentVisibility.HIDDEN_TO_PATIENT)) {
      visibility.push("non visible par le patient");
    }
    if (confidentialities.includes(DocumentVisibility.HIDDEN_TO_HEALTHCARE_PROFESSIONAL)) {
      visibility.push("masqué aux professionnels de santé");
    }
    if (confidentialities.includes(DocumentVisibility.HIDDEN_TO_LEGAL_REPRESENTATIVES)) {
      visibility.push("non visible par les représentants légaux");
    }
    return visibility.join(", ");
  }
  onChange(key, value) {
    let serializedValue;
    if (key == "serviceStartTimeFrom" || key == "serviceStopTimeTo") {
      serializedValue = value ? formatToISO8601Date(value) : undefined;
    } else if (key == "submissionStartTimeFrom") {
      serializedValue = value ? value.toISOString() : undefined;
    }
    if (key == "typeCodes" && value) {
      serializedValue = value.split(",");
    }
    serializedValue ||= value;
    this.args.context.searchParams[key] = serializedValue;
  }
  useLastSubmissionStartTimeFrom() {
    this.onChange("submissionStartTimeFrom", this.lastSubmissionStartTimeFrom);
  }
  get fromAndToDatesOnError() {
    return this.serviceStartTimeFromDate && this.serviceStopTimeToDate && this.serviceStartTimeFromDate > this.serviceStopTimeToDate;
  }
  async setCurrentDocumentMetadata(documentMetadata) {
    this.args.context.currentDocumentMetadata = documentMetadata;
    this.args.context.currentState = await this.args.context.calculateCurrentState();
  }
  onSubmit(event) {
    event.preventDefault();
    this.setLastDmpDocumentsSearchDate(new Date());
    this.args.context.transitionTo();
  }
}, _applyDecoratedDescriptor(_class.prototype, "setLastDmpDocumentsSearchDate", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setLastDmpDocumentsSearchDate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "useLastSubmissionStartTimeFrom", [action], Object.getOwnPropertyDescriptor(_class.prototype, "useLastSubmissionStartTimeFrom"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setCurrentDocumentMetadata", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setCurrentDocumentMetadata"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onSubmit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onSubmit"), _class.prototype), _class);
export { DocumentsRetrieveAccessFormSearchComponent as default };